var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('base-card',{staticClass:"px-5 py-3",attrs:{"color":"indigo","icon":"mdi-vuetify","inline":"","title":"Добавить контрагента"}},[_c('partner-form',{on:{"saveData":_vm.saveData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }